import { generateRandomNumber } from './generateRandomNumber';
const generateRandomString = () => `${generateRandomNumber()}`;
export { generateRandomString };
